import type {InterfaceStrings} from './strings'

export const it: InterfaceStrings = {
    nav: {
        beginSession: 'Inizia',
        faq: 'Domande',
        pricing: 'Prezzi',
        legal: 'Note legali',
        signIn: 'Accedi',
        viewPricing: 'Vedi i prezzi',
        signOut: 'Esci',
        account: 'Account',
        menu: 'Menu',
        closeMenu: 'Chiudi il menu',
        mainNav: 'Navigazione principale',
        sessions: {one: '{n} seduta', other: '{n} sedute'},
    },
    footer: {
        selfHypnosisFor: 'Autoipnosi per',
        anxiety: 'L’ansia',
        sleep: 'Il sonno',
        stress: 'Lo stress',
        confidence: 'La fiducia in sé',
        focus: 'La concentrazione',
        learn: 'Capire',
        ericksonian: 'Che cos’è l’ipnosi ericksoniana',
        aiHow: 'Come funziona l’ipnosi con l’IA',
        vsMeditation: 'Ipnosi o meditazione',
        methods: 'Metodi',
        languages: 'Lingue',
    },
    page: {
        cta: 'Inizia la tua seduta gratuita',
        hint: 'La prima seduta è gratuita',
        exploreFurther: 'Per approfondire',
        disclaimer:
            'Quies è uno strumento di benessere per il rilassamento e l’esplorazione di sé. Non è un dispositivo medico e non diagnostica, cura né guarisce alcuna condizione. Se stai attraversando una crisi di salute mentale, rivolgiti a un professionista qualificato.',
        transcript: 'Trascrizione',
        transcriptNote: 'Un estratto di una vera seduta Quies, così come è stata pronunciata.',
        breadcrumb: 'Percorso di navigazione',
    },
    pricing: {
        selectPlan: 'Scegli questo pacchetto',
        subscribe: 'Abbonati',
        perMonth: 'al mese',
        manageSubscription: 'Gestisci l’abbonamento',
        replayFree: 'Riascoltare una seduta passata è sempre gratuito.',
        offerLead: 'Ogni seduta riprende da dove si è fermata la precedente.',
    },
    session: {
        chooseLanguage: 'Scegli la tua lingua',
        changeLanguage: 'Cambia lingua',
        changeVoice: 'Cambia voce',
        previewVoice: 'Ascolta {voice}',
        stopPreview: 'Interrompi l’ascolto',
        continue: 'Continua',
        composing: 'Quies sta scrivendo la tua seduta',
        preparing: 'La tua meditazione è in preparazione',
        pickingUp: 'si riprende da dove avevi lasciato',
        today: 'Oggi',
        yesterday: 'Ieri',
        loading: 'Caricamento…',
        showEarlier: 'Mostra i precedenti ({count})',
        tryDifferentApproach: 'Prova un’altra strada',
        nothingAdded: 'Nessuna aggiunta',
        purchaseConfirmed: 'Acquisto confermato',
        firstSessionNote: 'La tua prima seduta è gratuita. Accederai prima di ascoltarla.',
    },
    threshold: {
        title: 'Accedi per ascoltare',
        message: 'La tua prima seduta è gratuita. Nessuna carta necessaria.',
        google: 'Continua con Google',
        sendLink: 'Inviami un link di accesso',
        sending: 'Invio in corso…',
        emailLabel: 'Indirizzo email',
        or: 'oppure',
        waitingTitle: 'Controlla la tua email',
        waitingBody: 'Abbiamo inviato un link di accesso a {email}.',
        sendAgain: 'Invia di nuovo',
        googleInstead: 'Accedi invece con Google',
        codeLabel: 'Oppure scrivi il codice di 6 cifre ricevuto per e-mail',
        codeSubmit: 'Continua',
        codeSubmitting: 'Verifica in corso…',
        codeWrong: 'Questo codice non è corretto.',
        codeDead: 'Questo codice non funziona più. Usa il link nell\'e-mail oppure chiedine uno nuovo.',
        errors: {
            invalidEmail: 'Inserisci un indirizzo email valido.',
            rateLimited: 'Troppi tentativi. Riprova tra qualche minuto.',
            sessionError: 'Qualcosa è andato storto con il tuo accesso. Aggiorna la pagina e riprova.',
            sendFailed: 'Non è stato possibile inviare l’email. Riprova.',
            sessionExpired: 'Il tuo accesso è scaduto. Aggiorna la pagina e riprova.',
            generic: 'Qualcosa è andato storto. Riprova.',
        },
    },
    player: {
        play: 'Riproduci',
        pause: 'Pausa',
        playAgain: 'Riascolta',
        seek: 'Posizione',
        eyesClosed: 'Occhi chiusi',
        openEyes: 'Apri gli occhi',
        paused: 'In pausa',
        unavailable: 'Audio non disponibile',
        untitled: 'Seduta Quies',
    },
    failure: {
        turnFailed: 'Qualcosa è andato storto da parte nostra. La tua risposta è conservata.',
        reconnecting: 'Riconnessione…',
        refusalTitle: 'Prendiamo un’altra strada',
        refusal: 'A una parte del tuo messaggio non è stato possibile rispondere. Prova a riformularlo, o invialo di nuovo.',
        openElsewhere: 'Questa seduta è aperta anche in un’altra finestra.',
        serviceDown: 'Al momento Quies non è raggiungibile. Niente di ciò che hai fatto è andato perso.',
        sessionsUsedTitle: 'Hai usato le tue sedute',
        voiceFailedTitle: 'La tua meditazione è scritta',
        voiceFailed: 'Non è stato possibile darle voce in questo momento. Non si perde nulla, e ridarle voce non costa nulla.',
        voiceStopped: 'La voce si è interrotta a metà. Può riprendere da dove si era fermata.',
        streamMissing: 'La tua meditazione è pronta, ma non è arrivata su questa pagina.',
        tapToListen: 'Tocca per ascoltare',
        fileFailed: 'Questa registrazione non si riesce a riprodurre. Si può ridare voce alla meditazione, senza costi.',
        recordingGone: 'Questa registrazione non è più conservata.',
        purchaseCancelled: 'Acquisto annullato. Non è stato addebitato nulla.',
        purchasePending: 'Il tuo pagamento è confermato. Le tue sedute stanno impiegando più del solito ad arrivare.',
        checkoutFailed: 'Non è stato possibile completare il pagamento. Non è stato addebitato nulla.',
        sessionEnded: 'Questa seduta è giunta al termine.',
        busy: 'Quies è molto richiesto in questo momento. La tua risposta è conservata; riprova tra un minuto.',
        tooLong: 'Questa seduta è diventata più lunga di quanto Quies possa contenere. Ti è stata restituita.',
        notSaved: 'Non è stato possibile salvare questo passaggio. Riprova per non perdere il filo.',
        meditationRefused:
            'Non è stato possibile scrivere questa meditazione come richiesto. Riformulala, o ricomincia: questa seduta ti sarà restituita.',
        meditationRefusedUncharged:
            'Non è stato possibile scrivere questa meditazione come richiesto. Riformulala, o ricomincia.',
        linkExpired: 'Il tuo link di accesso è scaduto. Richiedine uno nuovo.',
        oauthFailed: 'L’accesso si è interrotto. Riprova.',
        offline: 'Sei offline. La tua risposta partirà appena torni in linea.',
        voiceChanged: 'La tua voce non è più disponibile; un’altra voce leggerà questa meditazione.',
        voiceReturned: 'Non è stato ancora possibile dare voce alla meditazione. Questa seduta ti è stata restituita.',
        voiceFailedAgain: 'Non è stato ancora possibile dare voce alla meditazione.',
        voiceResuming: 'La voce sta riprendendo…',
        voiceLimited: 'In quest’ora sono già state lette diverse meditazioni per te. Riprova un po’ più tardi.',
        tryAgain: 'Riprova',
        rephrase: 'Riformula',
        resume: 'Riprendi',
        voiceAgain: 'Ridai voce',
        listen: 'Ascolta',
        continue: 'Continua',
        begin: 'Inizia una seduta',
        signIn: 'Accedi',
        checkAgain: 'Controlla di nuovo',
        sendLink: 'Invia il link magico',
        useEmail: 'Usa l’email',
    },
}
